import ListingCardTierPreview from './ListingCardTierPreview.component';

export default ListingCardTierPreview;